import React from 'react';
import { FormattedMessage } from 'react-intl';
import { OptionFormTypes } from '../../../../services/filtering/filter-form-render-service/option-form-types';
import { renderFormBasedOnType } from '../../../../services/filtering/filter-form-render-service/';
import { messages } from './messages';

export const NotesToBuyer = {
  id: 'notesToBuyer',
  displayName: <FormattedMessage {...messages.notesToBuyer} />,
  type: OptionFormTypes.TYPE_STRING,
  filterValue: 'NotesToBuyer',

  render: (criteriaInformations) => {
    return renderFormBasedOnType(OptionFormTypes.TYPE_STRING, criteriaInformations);
  },
};
